/* eslint-disable */
import React, { useState } from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

// import styles
import styles from './AlertBar.css';

const getDefaultStyle = (style, theme) => {
  return {
    root: style,
  };
};

/**
 * Alert Banner Component
 * @param {string} severity 'error' | 'info' | 'success' | 'warning'
 * @param {object} overridestyle 'custom style to override default style
 * @param {string} message Alert message
 * @param {boolean} autoClose Whether to automatically close (false by default)
 * @param {number} autoCloseDelay Delay in milliseconds
 * @param {Function} onClickClose Function to call when the modal is closed
 * @returns 
 */
const AlertBar = props => {
  const [open, setOpen] = useState(true);
  const {
    severity,
    overridestyle = null,
    message = '',
    autoClose = false,
    autoCloseDelay = 3000,
    onClickClose = () => {
      console.log('Alert Closed!');
    },
  } = props;

  const useStyles = makeStyles(theme => getDefaultStyle(overridestyle, theme));
  const classes = useStyles();

  // close the Alert POP-UP
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
    onClickClose();
  };

  setTimeout(() => {
    if (autoClose) {
      setOpen(false);
      onClickClose();
    }
  }, autoCloseDelay);

  const Alert = props => {
    return (
      <MuiAlert
        className={overridestyle && classes.root} // if not passed - default style of Alert
        elevation={6}
        variant="filled"
        iconMapping={{
          success: <CheckCircleOutlineIcon fontSize="inherit" />,
        }}
        {...props}
      />
    );
  };

  return (
    <React.Fragment>
      {open && (
        <Alert onClose={handleClose} severity={severity} {...props}>
          {message}
        </Alert>
      )}
    </React.Fragment>
  );
};

export default AlertBar;



// WEBPACK FOOTER //
// ./src/views/components/Common/AlertBar/AlertBar.jsx